import React from 'react'
import styles from "./Body.module.css"
import { FaLongArrowAltRight } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';
function Body(props) {
    const Navigate = useNavigate()
    return (
        <div ref={props.bodyview} className={styles.bodyelement}>
            
            <div className={styles.vision}>
                <h3 style={{ color: "#066263" }}>VISION</h3>
                <p>顧客の抱える課題を最もシンプルかつ効果的な方法で解決する。</p>
            </div>
            <div className={styles.vision} style={{ marginTop: "5rem" }}>
                <h3 style={{ color: "#066263" }}>VALUE</h3>
                <p>品質の高いサービスしか提供しない。</p>
                <p>すべてのプロセスにおいて最高のものしか提供しない。</p>
            </div>
            {!props.whyUs && <div className={styles.WwhyUsbutton}>
                <button onClick={() => Navigate('/why-us')}>Why Us<FaLongArrowAltRight /> </button>

            </div>}
        </div>
    )
}

export default Body